import * as yup from 'yup';

import { KASKOTYP } from '@/features/Sparten/shared/types';

export const baseKaskoSBSchema = yup.object({
  gleicheSB: yup.boolean().default(false),
  vollkasko: yup.string().default(''),
  teilkasko: yup.string().default(''),
});

export const kaskoSBVollkaskoSchema = baseKaskoSBSchema.concat(
  yup.object({
    vollkasko: yup.string().required(),
    teilkasko: yup.string().when('gleicheSB', {
      is: (val: boolean) => !val,
      then: yup.string().required(),
    }),
  }),
);

export const kaskoSBSchema = baseKaskoSBSchema.when('kaskoTyp', {
  is: (val: KASKOTYP) => val === KASKOTYP.VOLLKASKO,
  then: kaskoSBVollkaskoSchema,
});
